// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__No_oC","checkboxCol":"Table_checkboxCol__2pzo4","emailCol":"Table_emailCol__2rtOK","actionCol":"Table_actionCol__3VdAT"};